import { AxiosInstance } from 'axios';

import { BookingEventList } from '../../domain/entities/BookingEvent';
import securedAxios from '../../utils/secured-axios';
import { buildApiV2Url } from 'src/utils/request-url';

/**
 * NOTE: use coubic v2 api
 */

export class FullCalendarEventRepository {
  private api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  public async Search(publicId: string, startAt: string, endAt: string) {
    const path = buildApiV2Url(
      `/merchants/${publicId}/booking_events?renderer=fullcalendar&start=${startAt}&end=${endAt}`,
    );

    return this.api.get(path).then((response) => {
      return new BookingEventList(response.data);
    });
  }

  public async SearchWidget(
    publicId: string,
    startAt: string,
    endAt: string,
    servicePublicIds?: string[],
  ) {
    const queryServicePubIds = servicePublicIds
      ? `&resource_public_ids=${servicePublicIds}`
      : '';
    const path = buildApiV2Url(
      `/merchants/${publicId}/booking_events?renderer=widgetCalendar&start=${startAt}&end=${endAt}${queryServicePubIds}`,
    );

    return this.api.get(path).then((response) => {
      return new BookingEventList(response.data);
    });
  }
}

export default new FullCalendarEventRepository(securedAxios);
